<template>
    <div>
        <div class="text-right">
            <b-button v-b-toggle.collapse-1.collapse-2 variant="primary">
                <i class="fa fa-filter"></i>
                Filtros
            </b-button>
        </div>
        <b-collapse id="collapse-1" class="mt-2">
            <b-card>
                <div class="text-left">
                    <div class="row">
                        <div style="margin:2px">
                            <b-button v-b-toggle.filtroFinanceiro variant="primary" @click="limpar">
                                Filtros Financeiro
                            </b-button>
                        </div>
                    </div>
                </div>
                <b-collapse id="filtroFinanceiro" visible accordion="my-accordion" class="mt-2">
                    <b-card-header>
                        Filtro Financeiro
                    </b-card-header>
                    <div class="container">
                        <div class="row">
                            <div class="col">
                                <label>Empresa</label>
                                <multiselect
                                        :multiple="true"
                                        v-model="filtro.empresa"
                                        :disabled="isVendedorMaster"
                                        label="name"
                                        value="_id"
                                        track-by="_id"
                                        placeholder="Selecione uma empresa"
                                        :showLabels="false"
                                        :options="empresas"
                                ></multiselect>
                            </div>
                        </div>
                        <div class = "row">
                            <div class="col-4">
                                <label>Método Pagamento:</label>
                                <multiselect
                                        v-model="filtro.formaPagamento"
                                        :multiple="true"
                                        :taggable="true"
                                        :options="formasPagamento"
                                        :showLabels="false"
                                        :hide-selected="true"
                                        select-label=""
                                        label="name"
                                        value="code"
                                        track-by="code"
                                        :searchable="false"
                                        placeholder="Selecione a forma de pagamento">
                                </multiselect>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <label>Status Pagamento:</label>
                                <multiselect
                                        v-model="filtro.statusCobranca"
                                        label="name"
                                        value="code"
                                        track-by="code"
                                        placeholder="Selecione o status do pedido"
                                        :taggable="true"
                                        :hide-selected="true"
                                        :searchable="false"
                                        :options="statusCobranca"
                                        :multiple="true"
                                        :showLabels="false"
                                ></multiselect>
                            </div>
                            <div class="col-4">
                                <label> Data Inicial:</label>
                                <datepicker
                                        calendar-button-icon="fa fa-calendar-alt"
                                        clear-button
                                        :disabled-dates="disabledData"
                                        bootstrap-styling
                                        calendar-button
                                        v-model="filtro.dataInicial"></datepicker>
                            </div>
                            <div class="col-4">
                                <label>Data Final:</label>
                                <datepicker
                                        calendar-button-icon="fa fa-calendar-alt"
                                        clear-button
                                        :disabled-dates="disabledData"
                                        bootstrap-styling
                                        calendar-button
                                        v-model="filtro.dataFinal"></datepicker>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col text-left">
                            <div class="col">

                            </div>
                        </div>
                        <div class=" col text-right">
                            <div class="col">
                                <b-link @click="limpar" class="mr-2">Limpar</b-link>
                                <b-button v-b-toggle.collapse-1.collapse-2 @click="query" variant="primary">Aplicar</b-button>
                            </div>
                        </div>
                    </div>
                </b-collapse>
            </b-card>
        </b-collapse>
        <b-collapse id="collapse-2" visible class="mt-2">
            <div class="text-left" v-if="exibicaoFiltro.length > 0">
                        <span v-for="item in exibicaoFiltro" :key="item.name" >
                            <b-button  disable pil variant="primary" size="sm" style="margin:2px">
                            {{item.name}} : {{item.mostrar}}
                            </b-button>
                        </span>
            </div>
        </b-collapse>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import datepicker from 'vuejs-datepicker';
    import axios from "axios";
    import moment from "moment";

    export default {
        name: "FiltroFatura",
        props: {
            find: {
                type: Function,
                required: true
            },
            clear: {
                type: Function
            }
        },
        components: {
            datepicker,
            Multiselect
        },
        async created() {
            const empresa = await axios.get(`/api/juridica/?select=name%20_id`);
            this.empresas = empresa.data;

            if (this.isVendedorMaster) {
              this.filtro.empresa = [];
              this.filtro.empresa.push(this.empresa);
            }
        },
        computed: {
            baseURL(){
                return axios.defaults.baseURL;
            },
            formasPagamento() {
                return this.$store.getters.formasPagamento;
            },
            statusCobranca () {
                return this.$store.getters.statusCobranca;
            },
            statusPedido() {
                return this.$store.getters.statusPedido;
            },
            exibicaoFiltro() {
                return this.$store.getters.exibicaoFiltro;
            },
            filtro() {
                return this.$store.getters.filtroFatura;
            },
            isVendedorMaster () {
              return this.$store.getters.isVendedorMaster;
            },
            empresa () {
              return this.$store.getters.empresa || {}
            }
        },
        data() {
            var dataInicial = moment().toDate();
            var dataFinal = moment().subtract("6","month").startOf("month").toDate();
            return {
                empresas: [],
                disabledData:{
                    to:dataFinal,
                    from:dataInicial
                }
            }
        },
        methods: {
            async limpar() {
                await this.$store.dispatch('clearFiltros');

                if (this.clear) {
                    this.clear();
                }
            },
            async query() {
                await this.$store.dispatch('setFiltro', this.filtro);
                if (this.find) {
                    this.find();
                }
            }
        }
    }
</script>

<style scoped>

</style>
